import apiService from "./apiService"

const appointmentApiSlice = apiService.injectEndpoints({
  endpoints: (builder) => ({
    fetchAppointments: builder.query({
      query: (params) => ({ url: "appointment", params: params }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    sendReviewMessage: builder.mutation({
      query: (data) => ({
        url: `appointment/${data.appointmentid}/sendreviewmessage`,
        method: "POST",
        body: { ...data },
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
  }),
})

export default appointmentApiSlice

export const { useLazyFetchAppointmentsQuery, useSendReviewMessageMutation } =
  appointmentApiSlice
